export default "__VITE_ASSET__MHGvEzTu__"